import {Box, Link} from '@mui/material'
import {StaticImage} from 'gatsby-plugin-image'
import * as React from 'react'


export type FooterProps = {
  userAgreementUrl?: string
  privacyPolicyUrl?: string
}

export default function Footer(props: FooterProps) {
  const {
    userAgreementUrl = 'https://drive.google.com/file/d/1b5Q-UJDN2QIOk8U0YuCRe3WH0nThE5kw/view?usp=sharing',
    privacyPolicyUrl = 'https://drive.google.com/file/d/1u2K7Y2hPvKTLUzuCnfpVoojqBcc-SDvF/view?usp=sharing',
  } = props

  return (
    <footer style={{marginTop: `2rem`}}>
      <Box display='grid' gridTemplateColumns='1fr .5fr' gap={4} alignItems='center'>
        <Box typography='body2' color='text.disabled'>
          <Box>{new Date().getFullYear()} / VSELENUM</Box>
          <Box>ФОП АКСЄНОВ ІЛЛЯ АНДРІЙОВИЧ</Box>
          <Box><Link href={privacyPolicyUrl} target='_blank'>Политика конфиденциальности</Link></Box>
          <Box><Link href={userAgreementUrl} target='_blank'>Договор оферты</Link></Box>
        </Box>
        <Box p={2}>
          <StaticImage src='../images/Logo/Vselenum.png' alt='Логотип VSELENUM — Вселенная дорогого визуала' placeholder='none'/>
        </Box>
      </Box>
    </footer>
  )
}
